import { styled } from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { COLORS } from '@components/web/src/styles';

export const ThirdPartyConnectModalContainer = styled(Flexbox)`
  background-color: ${COLORS.base.white};
  border-radius: 16px;
`;
